var exports = {
  "kL": "BottomCTASection.module__container___aFZSNm",
  "DD": "BottomCTASection.module__title___aFZSNm",
  "UD": "BottomCTASection.module__buttonContainer___aFZSNm",
  "x6": "BottomCTASection.module__button___aFZSNm",
};

module.exports = exports;
